import cx from 'classnames';
import { TTypographyTextSize, TypographyTitleProps } from './types';
import { getCommonClassName } from './utils';
import { ElementType } from 'react';

const SIZE_CLASS_NAME_MAP: Record<TTypographyTextSize, string> = {
  large: 'slds-text-heading--large',
  medium: 'slds-text-heading--medium',
  small: 'slds-text-heading--small',
  inherit: ''
};

export const Title = <T extends ElementType = 'div'>({
  children,
  size = 'medium',
  component,
  className,
  strong,
  shadow,
  italic,
  color,
  align,
  textWrap,
  transform,
  underlineOnHover,
  ...props
}: TypographyTitleProps<T>) => {
  const Component = component || 'div';
  return (
    <Component
      className={cx(
        SIZE_CLASS_NAME_MAP[size],
        getCommonClassName({ strong, shadow, italic, color, className, align, textWrap, transform, underlineOnHover })
      )}
      {...props}
    >
      {children}
    </Component>
  );
};
